export const STATS = [
  { value: 15, prefix: "R$", suffix: "bi+", label: "VGL" },
  { value: 17, label: "Estados" },
  { value: 300, suffix: "+", label: "Lançamentos" },
  { value: 30, suffix: "+", label: "Anos de CNPJ" },
];

export const TIMELINE = [
  { year: 1995, event: "Fundação como agência de comunicação." },
  { year: 2005, event: "Foco exclusivo em mercado imobiliário." },
  { year: 2012, event: "Primeira parceria oficial Google." },
  { year: 2018, event: "Expansão para Cuiabá e Brasília." },
  { year: 2024, event: "R$15bi+ em VGL acumulado." },
];
